export const stacks = [
  {
    name: 'React JS',
    icon: 'react',
  },
  {
    name: 'CSS',
    icon: 'css3-alt',
  },
  {
    name: 'GIT',
    icon: 'git-alt',
  },
  {
    name: 'Firebase',
    icon: 'gripfire',
  },
  {
    name: 'HTML',
    icon: 'html5',
  },
  {
    name: 'JavaScript',
    icon: 'js',
  },
];

export default stacks;
